/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import {
  Container,
  Grid,
  Typography,
  Box,
  Button,
  TextField,
  Radio,
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  InputLabel,
  Divider,
  Stack,
  Link,
  Modal,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import _ from 'lodash';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder/lib';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Wizard, Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { getShippingTableData, submitCheckout, getShipToPartyData, clearCart } from '../../actions';
import { ModalComponent } from '../../components';
import { COLOR } from '../../helpers/colors';
import { breadcrumbNameMap } from '../../helpers/config';
import { formatAmount, roundToTwoDecimals } from '../../helpers/functions';
import CheckoutPlaceholder from './CheckoutPlaceholder';

const addressText = 'checkoutScreenTranslations:ADDRESS';

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: '',
      shipmentType: '',
      name: '',
      isPrivacyopen: false,
      addressData: {
        EmailAddress: '',
        Country: '',
        PostalCode: '',
        PhoneNumber: '',
        StreetName: '',
        BusinessPartnerName: '',
        CityName: '',
        isOpenVATPopup: false,
      },
      requestSubmitted: false,
      shipAmountData: {},
      customerReference: '',
      customerReferenceError: false,
    };
  }

  async componentDidMount() {
    await this.props.getShippingTableData(this.props.enqueueSnackbar);
    await this.props.getShipToPartyData(this.props.enqueueSnackbar);
    this.updatePickerData();
  }

  updatePickerData = () => {
    try {
      const { checkout } = this.props;
      const { shipToPartyDataArr } = checkout;
      if (shipToPartyDataArr.length > 0) {
        this.setState({
          addressData: shipToPartyDataArr[0],
          name: shipToPartyDataArr[0].BPCustomerNumber,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleChange = (e, type) => {
    this.setState({ selectedValue: e.target.value, shipmentType: type });
  };

  handleAddressChange = event => {
    try {
      const { checkout } = this.props;
      const { shipToPartyDataArr } = checkout;
      const address = shipToPartyDataArr.find(s => s.BPCustomerNumber === event.target.value);
      this.setState({ name: event.target.value, addressData: address });
    } catch (err) {
      console.log(err);
    }
  };

  handlePrivacyClick = () => {
    this.setState({ isPrivacyopen: true });
  };

  handleClose = () => {
    this.setState({ isPrivacyopen: false });
  };

  setRequestStatus = requestSubmitted => {
    this.setState(prevState => ({
      ...prevState,
      requestSubmitted,
    }));
  };

  handleSubmit = () => {
    try {
      const { shipmentType, name, customerReference } = this.state;
      const { cart, auth } = this.props;
      const { cartItems } = cart;
      const { selectedSalesOrgData, BusinessPartner, ContactPerson } = auth;
      const { SalesOrg, CheckoutRule } = selectedSalesOrgData;
      const availableItems = _.filter(cartItems, c => c.available);
      const nItemData = availableItems.map(c => {
        return {
          Material: c.Material,
          Qty: c.qty.toString(),
        };
      });
      const nHeaderData = {
        Vkorg: SalesOrg,
        Soldtoparty: BusinessPartner,
        Shiptoparty: name,
        PoRef: customerReference,
        ShipmentType: shipmentType,
        Contactperson: ContactPerson,
      };
      const data =
        CheckoutRule === '02'
          ? {
              N_CB2B_SO_HEADER_DATA: [nHeaderData],
              N_CB2B_SO_ITEM_DATA: nItemData,
            }
          : { N_ZAE_FM_CB2B_CREATE_SQ: [nHeaderData], N_ITEMS_DATA: nItemData };

      if (customerReference !== '') {
        this.setState({
          requestSubmitted: true,
          customerReferenceError: false,
        });
        const fmName =
          CheckoutRule === '02' ? 'CB2B_SO_HEADER_DATASet' : 'ZAE_FM_CB2B_CREATE_SQSet';
        this.props.submitCheckout(
          data,
          this.props.history,
          this.setRequestStatus,
          this.props.clearCart,
          this.props.enqueueSnackbar,
          fmName
        );
      } else {
        this.setState({ requestSubmitted: false, customerReferenceError: true });
      }
    } catch (error) {
      console.log('error at submit', error);
      this.setState({ requestSubmitted: false });
    }
  };

  returnPrice = data => {
    let count = 0;
    try {
      data.map(c => {
        count +=
          parseInt(c.qty, 10) *
          parseInt(c.MaterialGrossWeight !== undefined ? c.MaterialGrossWeight : 0, 10);
        return count;
      });
      return count;
    } catch (err) {
      console.log(err);
      return count;
    }
  };

  onNextChild = () => {
    try {
      const { checkout } = this.props;
      const { shippingDataArr } = checkout;
      let shipAmountData = {};
      shipAmountData = shippingDataArr.find(
        item => this.state.selectedValue === item.ShipmentTypeText
      );
      this.setState({ shipAmountData });
      this.wizard.nextStep();
    } catch (err) {
      console.log(err);
    }
  };

  handlePrivacyClick = () => {
    this.setState({ isOpenVATPopup: true });
  };

  handleClose = () => {
    this.setState({ isOpenVATPopup: false });
  };

  onClickEditCart = () => this.props.history.push('/cart');

  onChangeCustomerReferenceInput = e => this.setState({ customerReference: e.target.value });

  renderWizardStep1 = () => {
    const { addressData, name } = this.state;
    const { checkout, t } = this.props;
    const { shipToPartyDataArr, isLoading } = checkout;
    return (
      <Grid>
        <ReactPlaceholder
          showLoadingAnimation
          ready={!isLoading}
          customPlaceholder={<CheckoutPlaceholder />}
        >
          <Grid item xs={12} mt={3}>
            <Grid item xs={12} mt={2}>
              <Typography sx={{ fontSize: { xs: 18, sm: 18, md: 24 } }}>
                {t('checkoutScreenTranslations:SHIP_TO_PARTY')}
              </Typography>
              <Grid item container sx={{ mt: 2 }} xs={12} sm={12} md={5} direction="column">
                <FormControl fullWidth>
                  <Select
                    id="outlined-basic"
                    value={name}
                    onChange={this.handleAddressChange}
                    variant="outlined"
                  >
                    {shipToPartyDataArr.map(item => (
                      <MenuItem key={item.BPCustomerNumber} value={item.BPCustomerNumber}>
                        {item.BusinessPartnerName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Typography sx={{ fontSize: { xs: 18, sm: 18, md: 24 } }}>
                {t(addressText)}
              </Typography>
              <Divider />
              <Grid item container xs={12} direction="row" justifyContent="space-between">
                <Grid item container sx={{ mt: 2 }} xs={12} sm={12} md={5} direction="column">
                  <InputLabel htmlFor="component-helper">
                    {t('checkoutScreenTranslations:COMPANY_NAME')}
                  </InputLabel>

                  <TextField
                    id="outlined-basic"
                    value={addressData.BusinessPartnerName}
                    variant="outlined"
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid item container xs={12} direction="row" justifyContent="space-between">
                <Grid item container sx={{ mt: 2 }} xs={12} sm={12} md={5} direction="column">
                  <InputLabel htmlFor="component-helper">
                    {t('checkoutScreenTranslations:EMAIL')}
                  </InputLabel>

                  <TextField
                    id="outlined-basic"
                    value={addressData.EmailAddress}
                    variant="outlined"
                    disabled
                  />
                </Grid>
                <Grid item container sx={{ mt: 2 }} xs={12} sm={12} md={5} direction="column">
                  <InputLabel htmlFor="component-helper">
                    {t('checkoutScreenTranslations:MOBILE_NUM')}
                  </InputLabel>

                  <TextField
                    id="outlined-basic"
                    value={addressData.PhoneNumber}
                    variant="outlined"
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid item container xs={12} direction="row" justifyContent="space-between">
                <Grid item container sx={{ mt: 2 }} xs={12} sm={12} md={5} direction="column">
                  <InputLabel htmlFor="component-helper">{t(addressText)}</InputLabel>

                  <TextField
                    id="outlined-basic"
                    value={addressData.StreetName}
                    variant="outlined"
                    disabled
                  />
                </Grid>
                <Grid item container sx={{ mt: 2 }} xs={12} sm={12} md={5} direction="column">
                  <InputLabel htmlFor="component-helper">
                    {t('checkoutScreenTranslations:COUNTRY')}
                  </InputLabel>

                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    value={addressData.Country}
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid item container xs={12} direction="row" justifyContent="space-between">
                <Grid item container sx={{ mt: 2 }} xs={12} sm={12} md={5} direction="column">
                  <InputLabel htmlFor="component-helper">
                    {t('checkoutScreenTranslations:REGION')}
                  </InputLabel>

                  <TextField
                    id="outlined-basic"
                    value={addressData.CityName}
                    variant="outlined"
                    disabled
                  />
                </Grid>
                <Grid item container sx={{ mt: 2 }} xs={12} sm={12} md={5} direction="column">
                  <InputLabel htmlFor="component-helper">
                    {t('checkoutScreenTranslations:ZIPCODE')}
                  </InputLabel>
                  <TextField
                    id="outlined-basic"
                    value={addressData.PostalCode}
                    variant="outlined"
                    disabled
                    focused
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ReactPlaceholder>
      </Grid>
    );
  };

  renderWizardStep2 = () => {
    const { selectedValue } = this.state;
    const { cart, checkout, t } = this.props;
    const { shippingDataArr, priceData } = checkout;
    const { cartItems } = cart;
    const availableItems = _.filter(cartItems, c => c.available);
    const totalWeight = this.returnPrice(availableItems);
    return (
      <Grid item container xs={12} justifyContent="center" mt={2}>
        <Grid item xs={12} mt={2}>
          <Typography sx={{ fontSize: { xs: 18, sm: 18, md: 24 }, mb: 1 }}>
            {t('checkoutScreenTranslations:CHOOSE_SHIPPING_METHOD')}
          </Typography>
          <Divider />
          <TableContainer sx={{ mt: 2 }}>
            <Table aria-label="simple table">
              <TableHead
                sx={{
                  borderTop: `1px solid ${COLOR.borderColor}`,
                  background: COLOR.bgColor,
                }}
              >
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{
                      width: '9%',
                    }}
                  />

                  <TableCell
                    align="left"
                    sx={{
                      p: 1.5,
                      fontWeight: '600',
                      fontSize: { xs: 12, md: 14 },
                      width: '70%',
                    }}
                  >
                    {t('checkoutScreenTranslations:SHIPPING_METHOD')}
                  </TableCell>
                  {priceData.length > 0 ? (
                    <TableCell
                      align="left"
                      sx={{
                        p: 1.5,
                        fontWeight: '600',
                        fontSize: { xs: 12, md: 14 },
                      }}
                    >
                      {t('checkoutScreenTranslations:PRICE')}
                    </TableCell>
                  ) : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {shippingDataArr.map((s, index) => (
                  <TableRow
                    key={index.toString()}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      '&:hover th, &:hover td': {
                        backgroundColor: COLOR.bgColor,
                      },
                    }}
                  >
                    <TableCell component="th" scope="row" align="left" sx={{ p: 1.5, width: '9%' }}>
                      <Radio
                        checked={selectedValue === s.ShipmentTypeText}
                        onChange={e => this.handleChange(e, s.ShipmentType)}
                        value={s.ShipmentTypeText}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': 'A' }}
                        size="small"
                      />
                    </TableCell>
                    <TableCell component="th" scope="row" align="left" sx={{ p: 1.5 }}>
                      <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                      >
                        <Grid item>
                          <Typography
                            sx={{
                              fontSize: { xs: 12, md: 14 },
                              color: COLOR.textColor,
                            }}
                          >
                            {s.ShipmentTypeText}
                          </Typography>
                        </Grid>
                      </Grid>
                    </TableCell>

                    {priceData.length > 0 ? (
                      <TableCell
                        align="left"
                        sx={{
                          p: 1.5,
                          fontSize: { xs: 12, md: 14 },
                        }}
                      >
                        {formatAmount(
                          'en-AE',
                          totalWeight * parseInt(s.ConditionRateValue, 10),
                          s.ConditionRateValueUnit
                        )}
                      </TableCell>
                    ) : null}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    );
  };

  renderWizardStep3 = () => {
    const {
      addressData,
      shipAmountData,
      customerReference,
      customerReferenceError,
      isOpenVATPopup,
    } = this.state;
    const { cart, t } = this.props;
    const { cartItems } = cart;

    const availableItems = _.filter(cartItems, c => c.available);

    const totalWeight = this.returnPrice(availableItems);
    let cartTotal = 0;
    availableItems.forEach(c => {
      cartTotal += Number((roundToTwoDecimals(c.Price) + roundToTwoDecimals(c.Tax)) * c.qty);
    });

    const Total =
      cartTotal +
      Number(totalWeight * roundToTwoDecimals(shipAmountData.ConditionRateValue || '0'));
    const Currency = cartItems.length > 0 ? cartItems[0].Currency : '';

    return (
      <Grid item xs={12} sx={{ mt: 4, mb: 1 }}>
        <Stack>
          <Grid item container justifyContent="space-between" sx={{ mb: 2 }}>
            <Typography sx={{ fontSize: { xs: 18, sm: 18, md: 24 } }}>
              {t('checkoutScreenTranslations:REVIEW_ORDER')}
            </Typography>
            {availableItems.length > 0 ? (
              <Button
                variant="outlined"
                color="primary"
                sx={{ fontSize: { xs: 10, sm: 13, md: 14 } }}
                onClick={this.onClickEditCart}
              >
                {t('checkoutScreenTranslations:EDIT_CART')}
              </Button>
            ) : null}
          </Grid>
          <Divider />
        </Stack>
        <Box sx={{ mt: 2, mb: 2 }}>
          {availableItems.length > 0 ? (
            <>
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        sx={{
                          p: 1.5,
                          fontWeight: '600',
                          fontSize: { xs: 12, md: 14 },
                          width: '50%',
                        }}
                      >
                        {t('checkoutScreenTranslations:PRODUCT')}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          p: 1.5,
                          fontWeight: '600',
                          fontSize: { xs: 12, md: 14 },
                        }}
                      >
                        {t('checkoutScreenTranslations:QTY')}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          p: 1.5,
                          fontWeight: '600',
                          fontSize: { xs: 12, md: 14 },
                        }}
                      >
                        {t('checkoutScreenTranslations:PRICE')}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          p: 1.5,
                          fontWeight: '600',
                          fontSize: { xs: 12, md: 14 },
                        }}
                      >
                        Tax
                      </TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          p: 1.5,
                          fontWeight: '600',
                          fontSize: { xs: 12, md: 14 },
                        }}
                      >
                        {t('checkoutScreenTranslations:NET_VALUE')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {availableItems.map((c, index) => (
                      <TableRow
                        key={index.toString()}
                        sx={{
                          '&:last-child td, &:last-child th': {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell component="th" scope="row" align="left" sx={{ p: 1.5 }}>
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                          >
                            <img
                              src="/item_l.jpg"
                              alt=""
                              loading="lazy"
                              style={{ width: 110, height: 110 }}
                            />
                            <Grid item>
                              <Typography
                                sx={{
                                  fontSize: { xs: 12, md: 14 },
                                  mb: 0.75,
                                  pt: 0.75,
                                  cursor: 'pointer',
                                  '&:hover': {
                                    color: COLOR.linkColor,
                                  },
                                }}
                              >
                                {c.MaterialName}
                              </Typography>

                              <Typography sx={{ fontSize: { xs: 10, md: 12 }, marginBottom: 0.75 }}>
                                {c.Material}
                              </Typography>
                              <Typography
                                sx={{ fontSize: { xs: 12, md: 14 } }}
                              >{`${c.StockQuantity} ${c.StockQuantityUOM}`}</Typography>
                            </Grid>
                          </Grid>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            p: 1.5,
                            fontSize: { xs: 12, md: 14 },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 10, md: 12 },
                            }}
                          >
                            {c.qty}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            p: 1.5,
                            fontSize: { xs: 12, md: 14 },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 10, md: 12 },
                            }}
                          >
                            {formatAmount('en-AE', c.Price, c.Currency)}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            p: 1.5,
                            fontSize: { xs: 12, md: 14 },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 10, md: 12 },
                            }}
                          >
                            {formatAmount('en-AE', c.Tax, c.Currency)}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            p: 1.5,
                            fontSize: { xs: 12, md: 14 },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 10, md: 12 },
                            }}
                          >
                            {formatAmount(
                              'en-AE',
                              (roundToTwoDecimals(c.Price) + roundToTwoDecimals(c.Tax)) * c.qty,
                              c.Currency
                            )}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid item xs={12} sx={{ pt: 2 }}>
                <Divider />
                <Typography
                  sx={{
                    fontSize: { xs: 12, md: 14 },
                    textAlign: 'end',
                    mt: 2,
                  }}
                >
                  <span style={{ color: COLOR.helperTextColor }}>
                    {t('checkoutScreenTranslations:CART_TOTAL')}:
                  </span>{' '}
                  {formatAmount('en-AE', cartTotal, Currency)}
                </Typography>
              </Grid>
            </>
          ) : (
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  sx={{ fontSize: 32, color: COLOR.helperTextColor, textAlign: 'center' }}
                >
                  {t('checkoutScreenTranslations:CART_EMPTY')}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Box>

        <Divider />
        <Grid
          item
          container
          xs={12}
          sx={{ justifyContent: 'space-between', alignItems: 'baseline', mt: 2 }}
        >
          <Grid xs={6} item>
            <Typography
              sx={{
                fontSize: { xs: 16, md: 20 },
                mb: 1,
              }}
            >
              {t('checkoutScreenTranslations:SHIPPING_TO')}:
            </Typography>
            <Grid xs={12} item mt={0.75} container direction="row">
              <Typography
                color={COLOR.helperTextColor}
                sx={{
                  fontSize: { xs: 12, md: 14 },
                }}
              >
                {t('checkoutScreenTranslations:CLIENT')}:&nbsp;
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: 12, md: 14 },
                }}
              >
                {addressData.BusinessPartnerName}
              </Typography>
            </Grid>
            <Grid xs={12} item mt={0.75} container>
              <Typography
                sx={{
                  fontSize: { xs: 12, md: 14 },
                }}
                color={COLOR.helperTextColor}
              >
                {t(addressText)}:&nbsp;
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: 12, md: 14 },
                }}
              >
                {addressData.StreetName}
              </Typography>
            </Grid>
            <Grid xs={12} item mt={0.75} container>
              <Typography
                sx={{
                  fontSize: { xs: 12, md: 14 },
                }}
                color={COLOR.helperTextColor}
              >
                {t('checkoutScreenTranslations:PHONE_NUM')}&nbsp;
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: 12, md: 14 },
                }}
              >
                {addressData.PhoneNumber}
              </Typography>
            </Grid>
          </Grid>

          <Grid xs={6} item justifyContent="flex-end">
            <Grid xs={12} item mt={0.75}>
              <Typography
                sx={{
                  fontSize: { xs: 16, md: 20 },
                  textAlign: 'end',
                  mb: 1,
                }}
              >
                {t('checkoutScreenTranslations:ORDER_TOTAL')}:
              </Typography>
              {/* <Grid xs={12} item mt={0.75} container justifyContent="flex-end">
                <Typography
                  sx={{
                    fontSize: { xs: 12, md: 14 },
                    textAlign: 'end',
                  }}
                  color={COLOR.helperTextColor}
                >
                  {t('checkoutScreenTranslations:ITEMS')}:&nbsp;
                </Typography>
                {/* <Typography
                  sx={{
                    fontSize: { xs: 12, md: 14 },
                    textAlign: 'end',
                  }}
                >
                  {`${formatAmount('en-AE', cartTotal, 'AED')} AED`}
                </Typography>
              </Grid>
              */}
              {/* <Grid xs={12} item mt={0.75} container justifyContent="flex-end">
                <Typography
                  sx={{
                    fontSize: { xs: 12, md: 14 },
                    textAlign: 'end',
                  }}
                  color={COLOR.helperTextColor}
                >
                  Shipping Total:&nbsp;
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 12, md: 14 },
                    textAlign: 'end',
                  }}
                >
                  {formatAmount(
                    'en-AE',
                    totalWeight * parseInt(shipAmountData.ConditionRateValue, 10),
                    'AED'
                  )}
                </Typography>
              </Grid> */}
              <Grid xs={12} item mt={0.75} container justifyContent="flex-end">
                <Typography
                  sx={{
                    fontSize: { xs: 12, md: 14 },
                    textAlign: 'end',
                  }}
                  color={COLOR.helperTextColor}
                >
                  {t('checkoutScreenTranslations:TOTAL')}:&nbsp;
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 12, md: 14 },
                    textAlign: 'end',
                  }}
                >
                  {formatAmount('en-AE', Total, Currency)}
                </Typography>
              </Grid>
              <Grid xs={12} item mt={0.75} container justifyContent="flex-end">
                <Typography
                  sx={{
                    fontSize: { xs: 12, md: 14 },
                    textAlign: 'end',
                  }}
                  color={COLOR.helperTextColor}
                >
                  {t('checkoutScreenTranslations:TAX_CHARGES_APPLICABLE_TEXT')}*
                </Typography>
              </Grid>
              <Grid xs={12} item mt={0.75} container justifyContent="flex-end">
                <Button
                  variant="text"
                  color="primary"
                  onClick={this.handlePrivacyClick}
                  sx={{
                    fontSize: { xs: 12, md: 14 },
                    textAlign: 'end',
                  }}
                >
                  VAT Regulation
                </Button>
                <ModalComponent isOpen={isOpenVATPopup} onClose={this.handleClose} />
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={12} sm={8} md={3} item sx={{ mt: 3 }} container>
            <TextField
              fullWidth
              id="outlined-basic"
              variant="outlined"
              label={t('checkoutScreenTranslations:CUSTOMER_REFERENCE')}
              value={customerReference}
              onChange={this.onChangeCustomerReferenceInput}
              inputProps={{ maxLength: 35 }}
              helperText={
                customerReferenceError
                  ? t('checkoutScreenTranslations:PLEASE_ENTER_CUSTOMER_REFERENCE')
                  : ''
              }
              error={customerReferenceError}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  renderWizardStep4 = () => {
    const { t } = this.props;
    return (
      <Grid item container xs={12} justifyContent="center" height="250px" alignItems="center">
        <Paper
          variant="outlined"
          square
          justifyContent="center"
          alignItems="center"
          sx={{ width: '80%', height: 200, alignItems: 'center' }}
        >
          <Grid xs={12} item justifyContent="center" alignItems="center" mt={6.25}>
            <Typography
              sx={{
                fontSize: { xs: 12, md: 14 },
                textAlign: 'center',
              }}
            >
              {t('checkoutScreenTranslations:MSG')}
            </Typography>
          </Grid>
          <Grid xs={12} item justifyContent="center" alignItems="center" mt={0.75}>
            <Typography
              sx={{
                fontSize: { xs: 12, md: 14 },
                textAlign: 'center',
                fontWeight: 501,
                color: COLOR.formText,
              }}
            >
              {t('checkoutScreenTranslations:MSG2')}
            </Typography>
          </Grid>
          <Grid xs={12} item justifyContent="center" alignItems="center" mt={0.75}>
            <Typography
              sx={{
                fontSize: { xs: 12, md: 14 },
                textAlign: 'center',
                fontWeight: 501,
                color: COLOR.formText,
              }}
            >
              {t('checkoutScreenTranslations:MSG3')}
            </Typography>
          </Grid>
        </Paper>
      </Grid>
    );
  };

  render() {
    const { requestSubmitted, selectedValue } = this.state;
    const { cart, checkout, t, auth } = this.props;
    const { selectedSalesOrgData } = auth;
    const { CheckoutRule } = selectedSalesOrgData;
    const { shipToPartyDataArr, isLoading } = checkout;
    const { cartItems } = cart;
    const availableItems = _.filter(cartItems, c => c.available);
    const { state } = this.props.location;
    const isCheckout = state !== undefined ? state.isCheckout : false;

    return isCheckout || availableItems.length > 0 ? (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <Box sx={{ flexGrow: 1, marginY: 6, pb: 3 }}>
          <Wizard
            ref={ref => {
              this.wizard = ref;
            }}
            steps={[
              t(addressText),
              t('checkoutScreenTranslations:SHIPPING'),
              t('checkoutScreenTranslations:REVIEW'),
            ]}
            optional={[false, false, false]}
            onSubmit={this.handleSubmit}
            requestSubmitted={requestSubmitted}
            submitText={CheckoutRule === '02' ? 'Create Sales Order' : 'Create Sales Quotation'}
          >
            <Box nextValidation={shipToPartyDataArr.length > 0 && !isLoading}>
              {this.renderWizardStep1()}
            </Box>
            <Box nextValidation={selectedValue !== ''} onNextPress={this.onNextChild}>
              {this.renderWizardStep2()}
            </Box>
            <Box>{this.renderWizardStep3()}</Box>
            <Box>{this.renderWizardStep4()}</Box>
          </Wizard>
        </Box>
        <Modal
          open={this.state.isPrivacyopen}
          onClose={this.handleClose}
          aria-labelledby="privacy-policy-modal"
          aria-describedby="privacy-policy-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '90%',
              maxWidth: 600,
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              // color: '#FFFFFF',
            }}
          >
            <Typography id="privacy-policy-modal" variant="h6" component="h2">
              <strong>VAT Regulation</strong>
            </Typography>
            <Typography id="privacy-policy-modal-description" sx={{ mt: 2 }}>
              All Our Prices are VAT Inclusive By law, from the 1st of January 2018, all goods and
              services sold will be charged 5% for VAT. This includes all, but not limited to, our
              vehicles, accessories, parts & services.
              <br />
              All our pricing displayed are inclusive of VAT since the 1st of January 2018. If
              you&apos;d like to know more about VAT, please visit{' '}
              <Link href="https://www.tax.gov.ae/">https://www.tax.gov.ae/</Link>
            </Typography>
            <Button
              onClick={this.handleClose}
              sx={{
                mt: 'auto',
                ml: 'auto',
              }}
            >
              Close
            </Button>
          </Box>
        </Modal>
      </Container>
    ) : (
      <Redirect to={{ pathname: '/', state: { isCheckout: false } }} />
    );
  }
}

const mapStateToProps = state => {
  return {
    cart: state.cart,
    checkout: state.checkout,
    auth: state.auth,
  };
};
const cCheckout = connect(mapStateToProps, {
  getShippingTableData,
  submitCheckout,
  getShipToPartyData,
  clearCart,
})(Checkout);
const tCheckout = withTranslation(['checkoutScreenTranslations'])(cCheckout);
const sCheckout = withSnackbar(tCheckout);
export { sCheckout as Checkout };
